<template>
	<div class="display-flex flex-row flex-align-center radio-menu-container">
		<AnemicButton
			:key="option.value"
			class="radio-menu-button"
			v-for="option in BACKGROUND_MODES"
			:class="{ selected: backgroundMode === option.value }"
			@click="$emit('change-background-mode', option.value)"
		>
			{{ option.text }}
		</AnemicButton>
	</div>
</template>
<script>
import { BackgroundMode } from '@ply-io/ply-front-shared-utilities';

import { BACKGROUND_MODES } from '@/utils/workflow-service.const';
export default {
	name: 'FeatureBackgroundRadioMenu',
	props: { backgroundMode: { type: String, default: BackgroundMode.Off } },
	data() {
		return { BACKGROUND_MODES };
	},
};
</script>
<style scoped lang="scss">
.radio-menu-container {
	border-radius: 6px;
	background: #f9fafc;
	border: 1px solid #e7eaf3;
	width: 174px;
	height: 26px;

	.radio-menu-button {
		width: 58px !important;
		height: 26px !important;
		padding: 0px !important;
		font-size: 12px !important;
		color: #666767 !important;
		border-radius: 6px !important;
		font-weight: normal !important;
		background: transparent !important;

		&.selected {
			color: #6363ed !important;
			border: 1px solid #e7eaf3 !important;
			background: var(--bg-color) !important;
			box-shadow: 0px 1px 2px var(--shadow-color) !important;
		}
	}
}
</style>
